import axios from "axios";
import * as Constants from "../constant";
const editIsPrivate = async (id,IsPrivate) => {
	try {
        const response = await axios.patch(
			`${Constants?.LOCAL_URL}/space/Private/${id}`,IsPrivate
		);
		return response;
	} catch (error) {
		return error;
	}
};
export default editIsPrivate;
